import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }

import Pagination from '@/components/Pagination.vue'
import { getCurrentInstance, reactive, ref, onActivated } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import { getInvoiceListApi, checkInvoiceApi } from '@/apis/invoice'
import { InvoiceStatus } from '@/enums/invoice'
import { joinParams } from '@/utils/index'
import Keys from '@/constant/key'
import { UserMutationTypes } from '@/store/modules/user/mutation-types'
import { color } from 'echarts'


export default /*@__PURE__*/_defineComponent({
  __name: 'InvoiceList',
  setup(__props) {

const store = useStore()
const route = useRoute()
const router = useRouter()
const { proxy } = getCurrentInstance() as any
const userInfo = store.state.user.userInfo

const filters = reactive({
    type:           route.meta.v, // 1-商户端，2-账务端, 3- 供应商端
    invoice_name:   '',     // 发票名称/内容
    brand_name:     '',     // 商户名
    SellerName:     '',     // 开票单位
    InvoiceNum:     '',     // 发票号
    InvoiceType:    '',     // 发票类型
    status:         (route.meta.v == 2) ? 1 : '', // 发票状态，账务端默认待审核状态
    start_date:     '',     // 开票日期
    end_date:       '',     // 开票日期
    recive_start_date:'',   //收票开始日期
    recive_end_date:'',     //收票结束日期
    bet_start_date:'',      //预计付款开始日期
    bet_end_date:'',        //预计付款结束日期
    pay_start_date:'',      //实际付款开始日期
    pay_end_date:'',        //实际付款结束日期
    page:           1,
    page_size:      10,
})
const state = reactive({
    dialogVisibleNew:false,
})
const total = ref(0)
const changeColor = ({row,rowIndex}) => {
    if(row.if_red && row.if_red == 1) {
        return {color:"red"}
    }
}
// 获取发票列表
const tableData = ref([])
const getInvoiceList = async () => {
    const { code, data, msg } = await getInvoiceListApi(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    const {data:list = []} = data
    // 合并同一次上传的发票行
    for (let i=list.length-1; i>0; i--) {
        const item = list[i]
        const nextItem = list[i-1]
        if (item.invoice_id === nextItem.invoice_id) {
            nextItem.rowspan = (item.rowspan || 1) + 1
            item.rowspan = 0
        }
    }
    tableData.value = list
    total.value = data.total || 0
}
// 同时上传的发票合并
const objectSpanMethod = ({row, column, rowIndex, columnIndex}) => {
    if (row.rowspan !== undefined) {
        if (columnIndex === 0 || filters.type==2 && columnIndex==1) {
            return {
                rowspan: row.rowspan,
                colspan: 1
            }
        }
    }
}
// getInvoiceList()

// 多选监听及导出
const selectedIds = ref([])
const onSelectionChange = (val) => {
    selectedIds.value = val
}

const onExport = () => {
    let url = `${Keys.baseUrl}/invoice/invoice_export?${joinParams({...filters, user_id: userInfo.id, export: 1})}`
    if (selectedIds.value.length) {
        /**
         * 解决合并项选中问题
         * 1、获取到已选中的名称
         * 2、循环判断已选中名称，相同则保留 id
        */
        let invoiceList = tableData.value
        let names = selectedIds.value.map((item:any) => item.invoice_name) // 所有选中的发票名称（解决）
        let ids:any = []
        invoiceList.map((item:any) => {
            if (names.includes(item.invoice_name)) {
                ids.push(item.id)
            }
        })
        ids = ids.join(',')

        url = `${Keys.baseUrl}/invoice/invoice_export?${joinParams({ids, user_id: userInfo.id, export: 1})}`
    }

    window.open(url);
}
const onDel = (id) => {
    proxy.$confirm(`确定要删除吗？`, '提示', {
        type: 'warning'
    }).then(() => {
            proxy.$http.post('/invoice/invoice_deleted', {id}).then(res => {
                const {code, msg} = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                proxy.$message({ type: 'success', message: '删除成功' })
                getInvoiceList()
            })
    }).catch(() => {
        console.log('取消删除')
    })
}
// 更新状态，已收到4,已付款5
const onCheck = async (id,type) => {
    const {code, data, msg} = await checkInvoiceApi({id, type}) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    proxy.$message({ type: 'success', message: '审核完成' })
    getInvoiceList()
}

const onSearch = () => {
    filters.page = 1
    getInvoiceList()
}
const onPageChange = (val:number) => {
    filters.page = val
    getInvoiceList()
}
const onSizeChange = (val:number) => {
    filters.page_size = val
    getInvoiceList()
}
onActivated(() => {
    getInvoiceList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.invoice_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.invoice_name) = $event)),
        placeholder: "发票内容"
      }, null, 8, ["modelValue"]),
      (filters.type==2)
        ? (_openBlock(), _createBlock(_component_el_input, {
            key: 0,
            class: "filter-item",
            modelValue: filters.SellerName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.SellerName) = $event)),
            placeholder: "开票单位"
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.brand_name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.brand_name) = $event)),
        placeholder: "商户名"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.InvoiceNum,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.InvoiceNum) = $event)),
        placeholder: "发票号"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.InvoiceType,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.InvoiceType) = $event)),
        filterable: "",
        clearable: "",
        placeholder: "发票类型",
        style: {"width":"150px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "专票",
            value: "专票"
          }),
          _createVNode(_component_el_option, {
            label: "普票",
            value: "普票"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.status) = $event)),
        filterable: "",
        clearable: "",
        placeholder: "审核状态",
        style: {"width":"150px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: filters.type==1 || filters.type==3 ? '审核中' : '待审核',
            value: 1
          }, null, 8, ["label"]),
          _createVNode(_component_el_option, {
            label: "审核通过",
            value: 2
          }),
          _createVNode(_component_el_option, {
            label: "已驳回",
            value: 3
          }),
          _createVNode(_component_el_option, {
            label: "已收到",
            value: 4
          }),
          _createVNode(_component_el_option, {
            label: "已付款",
            value: 5
          }),
          _createVNode(_component_el_option, {
            label: "已过期",
            value: 6
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (filters.type == 2)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_el_date_picker, {
              class: "filter-item",
              modelValue: filters.start_date,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.start_date) = $event)),
              "value-format": "YYYY-MM-DD",
              placeholder: "开票日期",
              style: {"width":"150px"}
            }, null, 8, ["modelValue"]),
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
            _createVNode(_component_el_date_picker, {
              class: "filter-item",
              modelValue: filters.end_date,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.end_date) = $event)),
              "value-format": "YYYY-MM-DD",
              placeholder: "开票日期",
              style: {"width":"150px"}
            }, null, 8, ["modelValue"])
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.recive_start_date,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filters.recive_start_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "收票开始日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _cache[19] || (_cache[19] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.recive_end_date,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filters.recive_end_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "收票结束日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.bet_start_date,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((filters.bet_start_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "预计付款开始日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _cache[20] || (_cache[20] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.bet_end_date,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((filters.bet_end_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "预计付款结束日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.pay_start_date,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((filters.pay_start_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "实际付款开始日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _cache[21] || (_cache[21] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.pay_end_date,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((filters.pay_end_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "实际付款结束日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-item",
        type: "primary",
        onClick: onSearch
      }, {
        default: _withCtx(() => _cache[16] || (_cache[16] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      (filters.type == 1 || filters.type == 3)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            class: "filter-item",
            type: "primary",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(router).push(filters.type==1 ? '/merchant-admin/invoice-edit':'/supplier/invoice-edit')))
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [
              _createTextVNode("上传发票")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (filters.type == 2)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 3,
            class: "filter-item",
            type: "primary",
            onClick: onExport
          }, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [
              _createTextVNode("批量导出")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      border: "",
      onSelectionChange: onSelectionChange,
      "row-style": changeColor,
      "span-method": objectSpanMethod
    }, {
      default: _withCtx(() => [
        (filters.type==2)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              type: "selection"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "商户名"
        }),
        _createVNode(_component_el_table_column, {
          prop: "invoice_name",
          label: "发票内容"
        }),
        (filters.type==2)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              prop: "SellerName",
              label: "开票单位"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "InvoiceNum",
          label: "发票号码"
        }),
        _createVNode(_component_el_table_column, {
          prop: "InvoiceDate",
          label: "开票日期"
        }),
        _createVNode(_component_el_table_column, {
          prop: "InvoiceType",
          label: "发票类型"
        }),
        _createVNode(_component_el_table_column, {
          prop: "status",
          label: "审核状态"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(filters.type==1 && scope.row.status == 1 || filters.type==3 && scope.row.status == 1? '审核中' : _unref(InvoiceStatus)[scope.row.status]), 1)
          ]),
          _: 1
        }),
        (filters.type==1 || filters.type==3)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              prop: "TotalAmount",
              label: "发票金额"
            }))
          : _createCommentVNode("", true),
        (filters.type==2)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 3,
              prop: "AmountInFiguers",
              label: "价税合计"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "recive_time",
          label: "收票日期",
          width: "150"
        }),
        (filters.type==2)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 4,
              prop: "bet_paytime",
              label: "预计付款日期",
              width: "150"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "pay_time",
          label: "实际付款日期",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (_unref(router).push(filters.type==1?`/merchant-admin/invoice-edit?id=${scope.row.id}&t=${filters.type==1 || filters.type==3 ? 'view' : 'check'}`:`/supplier/invoice-edit?id=${scope.row.id}&t=${filters.type==1 || filters.type==3 ? 'view' : 'check'}`))
              }, {
                default: _withCtx(() => _cache[22] || (_cache[22] = [
                  _createTextVNode("查看")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              (filters.type==1 || filters.type==3)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (_unref(router).push(filters.type==1?`/merchant-admin/invoice-edit?id=${scope.row.id}&t=edit`:`/supplier/invoice-edit?id=${scope.row.id}&t=edit`)),
                    disabled: scope.row.status==1 || scope.row.status==2 || scope.row.status==4
                  }, {
                    default: _withCtx(() => _cache[23] || (_cache[23] = [
                      _createTextVNode("编辑")
                    ])),
                    _: 2
                  }, 1032, ["onClick", "disabled"]))
                : _createCommentVNode("", true),
              (filters.type==2 && (scope.row.status == 2 || scope.row.status ==4))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    onClick: ($event: any) => (onDel(scope.row.id)),
                    type: "primary",
                    size: "small"
                  }, {
                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                      _createTextVNode("删除")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (filters.type==2 && scope.row.status==2)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    style: {"margin-top":"10px"},
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (onCheck(scope.row.id,4))
                  }, {
                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                      _createTextVNode("已收到")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (filters.type==2 && scope.row.status==4)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 3,
                    style: {"margin-top":"10px"},
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (onCheck(scope.row.id,5))
                  }, {
                    default: _withCtx(() => _cache[26] || (_cache[26] = [
                      _createTextVNode("已付款")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"])
  ]))
}
}

})